import interceptor from '@/plugins/interceptor';


export default {
    actions: {
        async contentEditor_module(_, id) {
            return await interceptor.authenticate.get(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}/modulesCfg/${id}`
            );
        },
        async contentEditor_getContentCfg(_, id) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/${id}`);
        },
        async contentEditor_editContent(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/${params.id}`, params);
        },
        async contentEditor_changeOrder(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/orderNumbers`, params);
        },
        async contentEditor_changeFinalPracticeType(_, params) {
            return await interceptor.authenticate.patch(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/coursesCfg/${params.courseId}/finalPracticeType`, {newType: params.type});
        },
        async contentEditor_createContent(_, params) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg`, params);
        },
        async contentEditor_removeContent(_, params) {
            return await interceptor.authenticate.delete(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/${params.contentId}`, params);
        },
        async contentEditor_updateCommentsWallHeaders(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/${params.contentCfgId}/commentsWall/headers`, params.headerChanges);
        },
        async contentEditor_courseTree(_, courseCfgId) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/contentsCfg/${courseCfgId}/tree`);
        },
    }
}  
